// extracted by mini-css-extract-plugin
export default {"declaration":"Declaration_declaration__s4qPF"};